module.exports = __webpack_public_path__ + "static/media/m9.7d2a92ab.png";